import React from 'react';
import { Link } from 'react-router-dom';
import { StickyNote, Sun, Moon, Plus } from 'lucide-react';
import SearchAutocomplete from './SearchAutocomplete';

export default function Header({ query, setQuery, theme, toggleTheme, onOpenNotes, onOpenSuggest }) {
  return (
    <header className="site-header">
      <div className="header-top">
        <h1 className="site-title">AI Framework</h1>
        <div className="header-actions">
          <Link to="/submit" className="pill-btn primary" data-testid="header-submit-link">
            <Plus size={14} />
            <span>Submit a tool</span>
          </Link>
          <button className="pill-btn" onClick={onOpenSuggest} type="button">
            <Plus size={14} />
            <span>Quick suggest</span>
          </button>
          <button className="pill-btn" onClick={onOpenNotes} type="button">
            <StickyNote size={14} />
            <span>Notes</span>
          </button>
          <button className="pill-btn" onClick={toggleTheme} type="button">
            {theme === 'dark' ? <Sun size={14} /> : <Moon size={14} />}
            <span>{theme === 'dark' ? 'Light' : 'Dark'}</span>
          </button>
        </div>
      </div>
      <div className="search-wrap">
        <SearchAutocomplete
          variant="tree"
          placeholder="Search tools, creators, companies… (also filters the tree)"
          onQueryChange={setQuery}
        />
      </div>
    </header>
  );
}
